import { z } from 'zod';

import { schemaSlaceEvent } from '../SlaceEvent';

// https://docs.slace.com/docs/stoplight-docs-core/577dff16de638-send-event#request-body
export const schemaSendSlaceEventRequestBody = z.object({
    channel_id: z.string().optional(),
    destination: z.enum(['interaction', 'rewards', 'contact']),
    organization_id: z.string(),
    // depends on the destination and type
    payload: schemaSlaceEvent.optional(),
    type: z.string(),
});
export type SchemaSendSlaceEventRequestBody = z.infer<typeof schemaSendSlaceEventRequestBody>;
